import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    // Si el scroll está más abajo, sube al inicio
    if (scrollPosition > 1) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;